import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'autocomplete-dropdown',
    templateUrl: './autocomplete-dropdown.component.html',
    styleUrls: ['./autocomplete-dropdown.component.scss'],
})

export class AutocompleteDropdownComponent<T extends object> implements OnChanges {
    @Input() options: T[] | null = [];
    @Input() selectedValue: T | null = null;
    @Input() displayWith: (option: T) => string = (option) => (option as any)?.name ?? option;
    @Input() label = 'Select';
    @Input() className: string = '';
    @Input() disabled = false;
    @Output() selectionChange = new EventEmitter<T>();
    public inputControl = new FormControl<T | string>('');
    public searchTerm = '';
    public filteredOptions$: Observable<T[]>;

    private filteredOptionsSubject = new BehaviorSubject<T[]>([]);

    public constructor() {
        this.filteredOptions$ = this.filteredOptionsSubject.asObservable();
        this.inputControl.valueChanges.subscribe((term) => {
            if (typeof term === 'string') {
                this.filterOptions(term);
            }
        });
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['disabled']) {
            if (this.disabled) {
                this.inputControl.disable();
            } else {
                this.inputControl.enable();
            }
        }

        if (changes['options'] || changes['selectedValue']) {
            if (this.selectedValue) {
                this.inputControl.setValue(this.selectedValue, { emitEvent: false });
            }
            this.filterOptions(this.displayWith(this.selectedValue));
        }
    }

    public onSelect(option: T): void {
        this.selectedValue = option;
        this.inputControl.setValue(option, { emitEvent: false });
        this.selectionChange.emit(option);
    }

    private filterOptions(term: string = ''): void {
        const filtered = (this.options ?? []).filter((option) =>
            this.displayWith(option).toLowerCase().includes(term.toLowerCase())
        );
        this.filteredOptionsSubject.next(filtered);
    }
}